import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import api from "utils/api";
import { useAuth } from "context/AuthContext";
import {
  MdArrowBack,
} from "react-icons/md";

export default function EditRunner() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { userId } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_no: "",
    password: "",
    role: "R",
    status: 1,
    user_id: null,
  });

  const [loading, setLoading] = useState(true);

  const loadUser = async () => {
    try {
      const res = await api.post("/list_single_user", { user_id: id });

      if (res.data.length > 0) {
        const user = res.data[0];
        setFormData({
          name: user.name,
          email: user.email,
          mobile_no: user.mobile_no,
          password: "",
          role: user.role,
          status: user.status,
          user_id: user.id,
        });
      } else {
        toast.error("User not found");
        navigate("/admin/runner-boys");
      }
    } catch (err) {
      toast.error("Failed to load user");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/edit_user", {
        ...formData,
        admin_id: userId,
      });

      toast.success("User updated successfully");
      navigate("/admin/runner-boys");
    } catch (err) {
      toast.error("Failed to update user");
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="rounded-xl bg-white p-6 shadow-md">
          Loading...
        </div>
      </div>
    );
  }

  return (

    <div className="min-h-screen bg-gray-50 p-8">

      <div className="w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/admin/runner-boys")}
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
              aria-label="Back to Runner Boys"
            >
              <MdArrowBack className="h-5 w-5" />
            </button>
            <div>
              <h1 className="text-2xl font-semibold text-gray-800">
                Edit {formData.role === "A" ? "Admin" : "Runner boy"}
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Modify runner account details and permissions
              </p>
            </div>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">

          <div className="grid md:grid-cols-2 gap-5">

            <div>
              <label className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm
  focus:outline-none focus:border-gray-400 transition"
                required
              />
            </div>

            <div>
              <label className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm
  focus:outline-none focus:border-gray-400 transition"
                required
              />
            </div>

            <div>
              <label className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
                Phone
              </label>
              <input
                type="text"
                name="mobile_no"
                value={formData.mobile_no}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm
  focus:outline-none focus:border-gray-400 transition"
              />
            </div>

            <div>
              <label className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Leave blank to keep current password"
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm
  focus:outline-none focus:border-gray-400 transition"
              />
              <p className="text-xs text-gray-400 mt-2">
                Only enter a password if you want to update it.
              </p>
            </div>

          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4">
            <button
              type="button"
              onClick={() => navigate("/admin/runner-boys")}
              className="rounded-lg border px-4 py-2"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="rounded-lg bg-brand-500 
        px-5 py-2.5 text-sm font-semibold text-white 
        shadow-sm transition-all duration-200 
        hover:shadow-md hover:scale-[1.02]"
            >
              Update Runner
            </button>
          </div>

        </form>

      </div>
    </div>

  );
}